import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { format } from "date-fns";
import * as React from "react";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { HttpRequest } from "util/http";
import { DataGrid } from "../../components/ui/DataGrid";
import { FontAwesomeIcon } from "../../components/ui/FontAwesomeIcon";
import { Popover } from "../../components/ui/Popover";
import { RadioGroup } from "../../components/ui/RadioGroup";
import { Tooltip } from "../../components/ui/Tooltip";
import { StatusTypesEndpoint } from "../../util/http/endpoints";
import { userData } from "../../util/userData";
import { ActionAlertFormContainer } from "../ActionAlertFormContainer";
import { getActionStatusIcon } from "../CoachingFormContainer/util";
import { IStatusTypes } from "../CoachingFormStatus/interfaces";
import { alertDetails, Status } from "../MyAlertsContainer/interfaces";
import { getBulkCustomerInfo } from "../MyAlertsContainer/lib/http";
import {
  compareCustomerName, compareCustomerNameOnStatusReport,
  getListOfIndividualSurveyIdsFromStatusReport,
  resolveCustomerNameOnStatusReport,
} from '../MyAlertsContainer/lib/utils';
import { ReportsFilersBar } from "./filtersBar";
import {
  actionAlert,
  Assignee,
  Average,
  Avid,
  containerProps,
  containerState,
  hierPath,
  IChartExportOptions,
} from "./interfaces";
import ExportChart from "./lib/export";

require("highcharts/modules/exporting")(Highcharts);

export class ActionAlertsReportsContainer extends React.Component<containerProps, containerState> {
  state: containerState = {
    filters: undefined,
    records: [],
    filteredRecords: [],
    series: {
      byMonth: [],
      byQuarter: [],
      byYear: [],
      byAssignee: []
    },
    trendGrpahLoading: true,
    barGrpahLoading: true,
    recordsLoading: true,
    isCustomerDataFetching: false,
    trendGraphOptions: undefined,
    trendGraphOptionsToBar: undefined,
    barGraphOptions: undefined,
    avgTimetoResolution: 0,
    sortBy: 'createdDate',
    sortOrder: 'desc',
    reportExpanded: '',
    actionAlertFormOpen: false,
    selectedAlertID: undefined,
    dictAvidPaths: new Set(),
    statusTypes: [],
    statuses: [],
    hiddenProperties: [],
    chartBarOptions: {
      dropdownOpen: false,
      orderBy: "value",
      orderByValue: "descending",
      orderByValueOptions: [{ isEnabled: true, isChecked: false, label: 'Ascending' }, { isEnabled: true, isChecked: true, label: 'Descending' }],
      orderByAssignee: "descending",
      orderByAssigneeOptions: [{ isEnabled: true, isChecked: false, label: 'Ascending' }, { isEnabled: true, isChecked: true, label: 'Descending' }],
    },
    trendExportOptions: {
      dropdownOpen: false,
      list: ['print', 'png', 'jpeg', 'pdf', 'svg']
    },
    barChartExportOptions: {
      dropdownOpen: false,
      list: ['print', 'png', 'jpeg', 'pdf', 'svg']
    },
    AvidList: [],
    filteredAvidList: [],
    userId: undefined,
    customerInfoList: []
  }
  constructor(props) {
    super(props);

    this.exportTrendChart = this.exportTrendChart.bind(this);

  }

  componentDidMount() {
    this.loadStatuses();
    window.addEventListener('graphLoaded', () => this.setState({ trendGrpahLoading: false }))
    window.addEventListener('barGraphLoaded', () => this.setState({ barGrpahLoading: false }))
    this.state.assigneeChartRef = React.createRef();
    this.state.trendChartRef = React.createRef();
    this.state.trendChartRefToBar = React.createRef();

    window.addEventListener('updateRecords', () => {
      this.setState({ actionAlertFormOpen: false }, () => {
        this.getRecords()
      });
    })
  }

  componentWillUnmount() {
    window.removeEventListener('graphLoaded', () => this.setState({ trendGrpahLoading: false }))
    window.removeEventListener('barGraphLoaded', () => this.setState({ barGrpahLoading: true }))
  }

  getRecords() {
    this.setState({ recordsLoading: true }, () => {
      let filters = Object.assign(this.state.filters)
      if (filters) {
        let data = { lowerLimit: filters.periodFilter.split('-')[0], upperLimit: filters.periodFilter.split('-')[1], hier: userData.getFilters()['hier'], project: userData.getCurrentProject() };
        const method = 'POST';
        HttpRequest.fetch('scripts/action_alerts_reports/getReport', { data, method })
          .then((res: actionAlert[]) => {
            getBulkCustomerInfo(userData.getCurrentProject(), getListOfIndividualSurveyIdsFromStatusReport(res).join(',')).then((individualSurveysCustomerInfo) => {
              this.setState({ customerInfoList: individualSurveysCustomerInfo ? individualSurveysCustomerInfo : [] })
            })
            userData.getUserId().then((userId) => {
              let alerts = res.map((record) => {
                if (!record.severityLabel) {
                  record.severityLabel = 'Low';
                  record.severityColor = '#6c757d';
                }
                if (!record.actionItemReason) record.actionItemReason = 'No Reason for Alert Assigned'
                if (!record.actionItemStatus) record.actionItemStatus = 'No Status Assigned'
                if (!record.src) record.src = 'No Source Assigned'
                if (record.src == 'Coaching Form') record.src = 'Survey'
                if (!record.rootCause) record.rootCause = 'No Root Cause Assigned'
                return record;
              });
              if (!this.state.userId) this.setState({ userId: userId });
              this.setState({ records: alerts, filteredRecords: alerts }, () => {
                this.updateFilteredRecords();
                this.generateSeries();
                this.setState({ recordsLoading: false });
              })
            })
          });
      }
    });
  }

  /**
   * Looks for parent avids until it gets the highest Hierarchy -> 'Banwide_0'
   * @param avid starting point
   * @param trail
   */
  getRecordHierTrail(avid: string, trail: string[]) {
    if (avid != '-1') {
      const data = { currentHierarchy: avid, current_project: 'ABCU' }
      const method = 'POST';
      HttpRequest.fetch<Avid>('scripts/admin_action_alerts/get_avid', { data, method })
        .then((res) => {
          if (res.prevLink != '-1')
            trail.push(res.prevLink);
          return this.getRecordHierTrail(res.prevLink, trail);
        })
    } else {
      let dictAvidPaths = new Set(this.state.dictAvidPaths);
      const trace = trail.reverse();
      // trace.forEach((step, idx) => {
      //   if (!dictAvidPaths.has(step)) {

      //   }
      // });
      let hierPath: hierPath = {
        avid: trace[trace.length - 1],
        path: trace
      }
      dictAvidPaths.add(hierPath);
      console.log(this.state.dictAvidPaths)
    }
  }

  generateSeries() {
    const { filteredRecords, filters } = this.state;
    let { series } = this.state;
    let itemsResolvedByMonth = 0,
      sumByMonth = 0,
      resultByMonth = 0,
      itemsResolvedByQuarter = 0,
      sumByQuarter = 0,
      resultByQuarter = 0,
      itemsResolvedByYear = 0,
      sumByYear = 0,
      resultByYear = 0,
      avgTimetoResolution = 0,
      avgTimetoResolutionSum = 0,
      avgTimetoResolutionItemsResolved = 0;
    let currentMonth: number = undefined,
      currentQuarter: number = undefined,
      currentYear: number = undefined;
    let assignees = new Map();
    series.byMonth = [];
    series.byQuarter = [];
    series.byYear = [];
    series.byAssignee = [];
    filteredRecords.forEach((record, idx) => {
      if (currentMonth != record.month || currentYear != record.year || idx == (filteredRecords.length - 1)) {
        // calculating new month
        currentMonth = record.month;
        if (itemsResolvedByMonth > 0) {
          // Calculate average
          if (idx == (filteredRecords.length - 1)) {
            // this is the last item of the month, it has to add its numbers to month totals
            sumByMonth += record.timeToResolution
            itemsResolvedByMonth += (record.resolved ? 1 : 0);
          }
          resultByMonth = sumByMonth / itemsResolvedByMonth;


          // Prepare labels
          let currentLabel = format(new Date(record.createdDate), 'MMMM yyyy');
          let prevLabel = format(new Date(filteredRecords[idx - 1].createdDate), 'MMMM yyyy');


          const average: Average = {
            sum: sumByMonth,
            label: ((idx == filteredRecords.length - 1) ? currentLabel : prevLabel),
            result: resultByMonth,
            itemsResolved: itemsResolvedByMonth
          }
          series.byMonth.push(average);
          sumByMonth = 0;
          itemsResolvedByMonth = 0;
        }
      }

      if (currentQuarter != record.Quarter || currentYear != record.year || idx == (filteredRecords.length - 1)) {
        // calculating new quarter
        currentQuarter = record.Quarter;
        if (itemsResolvedByQuarter > 0) {
          // Calculate average
          resultByQuarter = sumByQuarter / itemsResolvedByQuarter;
          // Prepare labels
          let currentLabel = (currentQuarter).toString() + ' Q ' + (record.year).toString();
          let prevLabel = (filteredRecords[idx - 1].Quarter).toString() + ' Q ' + (filteredRecords[idx - 1].year).toString();
          const average: Average = {
            sum: sumByQuarter,
            label: ((idx == filteredRecords.length - 1) ? currentLabel : prevLabel),
            result: resultByQuarter,
            itemsResolved: itemsResolvedByQuarter
          }
          series.byQuarter.push(average);
          sumByQuarter = 0;
          itemsResolvedByQuarter = 0;
        }
      }

      if (currentYear != record.year || idx == (filteredRecords.length - 1)) {
        // calculating new quarter
        currentYear = record.year;
        if (itemsResolvedByYear > 0) {
          // Calculate average
          resultByYear = sumByYear / itemsResolvedByYear;
          // Prepare labels
          let currentLabel = (currentYear).toString();
          let prevLabel = (filteredRecords[idx - 1].year).toString();
          const average: Average = {
            sum: sumByYear,
            label: ((idx == filteredRecords.length - 1) ? currentLabel : prevLabel),
            result: resultByYear,
            itemsResolved: itemsResolvedByYear
          }
          series.byYear.push(average);
          sumByYear = 0;
          itemsResolvedByYear = 0;
        }
      }
      itemsResolvedByMonth += (record.resolved ? 1 : 0);
      itemsResolvedByQuarter += (record.resolved ? 1 : 0);
      itemsResolvedByYear += (record.resolved ? 1 : 0);
      avgTimetoResolutionItemsResolved += (record.resolved ? 1 : 0);
      sumByMonth += record.timeToResolution;
      sumByQuarter += record.timeToResolution;
      sumByYear += record.timeToResolution;
      avgTimetoResolutionSum += record.timeToResolution;

      // by assignee
      let assignee: Assignee;
      const assigneeUsername = (record.assignedTo ? record.assignedTo : 'Non specified');
      if (assignees.has(assigneeUsername)) {
        assignee = assignees.get(assigneeUsername);
        assignee.avgObj.itemsResolved += (record.resolved ? 1 : 0);
        assignee.avgObj.sum += record.timeToResolution;
        assignee.avgObj.result = (assignee.avgObj.itemsResolved > 0 ? assignee.avgObj.sum / assignee.avgObj.itemsResolved : 0);
      } else {
        assignee = {
          username: assigneeUsername,
          avgObj: {
            label: assigneeUsername,
            itemsResolved: (record.resolved ? 1 : 0),
            sum: (record.timeToResolution ? record.timeToResolution : 0),
            result: (record.timeToResolution ? record.timeToResolution : 0)
          },
        }
      }
      assignees.set(assigneeUsername, assignee);
    });

    if (avgTimetoResolutionItemsResolved > 0) {
      avgTimetoResolution = avgTimetoResolutionSum / avgTimetoResolutionItemsResolved;
    }
    let orderedAssignees = [];
    assignees.forEach(assignee => {
      orderedAssignees.push({ username: assignee.username, avgObj: assignee.avgObj, avg: assignee.avgObj.result });
    });

    // Sorting section for assignees
    const { chartBarOptions } = this.state;
    const valueDesc = (a, b) => {
      if (a.avg > b.avg) {
        return -1;
      }
      if (a.avg < b.avg) {
        return 1;
      }
      return 0;
    }

    const valueAsc = (a, b) => {
      if (a.avg < b.avg) {
        return -1;
      }
      if (a.avg > b.avg) {
        return 1;
      }
      return 0;
    }

    const userDesc = (a, b) => {
      const usernameA = a.username[0].toLowerCase();
      const usernameB = b.username[0].toLowerCase();
      if (usernameA > usernameB) {
        return -1;
      }
      if (usernameA < usernameB) {
        return 1;
      }
      return 0;
    }

    const userAsc = (a, b) => {
      const usernameA = a.username[0].toLowerCase();
      const usernameB = b.username[0].toLowerCase();
      if (usernameA < usernameB) {
        return -1;
      }
      if (usernameA > usernameB) {
        return 1;
      }
      return 0;
    }

    if (chartBarOptions.orderBy == 'value') {
      if (chartBarOptions.orderByValue == 'ascending')
        orderedAssignees.sort((a, b) => valueAsc(a, b));
      else orderedAssignees.sort((a, b) => valueDesc(a, b));
    } else {
      if (chartBarOptions.orderByAssignee == 'ascending')
        orderedAssignees.sort((a, b) => userAsc(a, b));
      else orderedAssignees.sort((a, b) => userDesc(a, b));
    }

    orderedAssignees.forEach((assignee) => {
      series.byAssignee.push(assignee.avgObj);
    });

    this.setState({ series: series, avgTimetoResolution: Number(avgTimetoResolution.toFixed(2)) }, () => {
      this.updateTrendGraph(filters.trendActiveFilter, (this.state.reportExpanded == 'trend'));
      this.updateBarGraph((this.state.reportExpanded == 'assignee'));
    });
  }

  updateTrendGraph(trendBy: string, expanded: boolean) {
    const { series, filters, avgTimetoResolution } = this.state;
    let data = series['by' + trendBy].map((item) => { return Number(item.result.toFixed(2)) });
    if (data.length === 0) data.push(0)
    let categories = series['by' + trendBy].map((item) => { return item.label });
    if (categories.length === 0 && filters.periodFilter.length > 0) categories.push(format(new Date(filters.periodFilter.split('-')[0].split('/').join('-')), 'MMMM yyyy'));
    let startDate = '';
    let endDate = '';

    if (filters && filters.periodFilter) {
      const startDate = format(new Date(filters.periodFilter.split('-')[0].split('/').join('-')), 'M/d/yyyy');
      const endDate = format(new Date(filters.periodFilter.split('-')[1].split('/').join('-')), 'M/d/yyyy');
    }

    const trendGraphOptions = {
      exporting: {
        filename: 'average-days-to-resolution',
        chartOptions: {
          title: {
            text: `
            <b>Average Days to Resolution by ${trendBy}</b><br/>
            <span style="text-align: center; color: #9E9E9E; font-size: small">${startDate} - ${endDate}</span><br/>
            <span style="text-align: center; color: #9E9E9E; font-size: small">Average: ${avgTimetoResolution}</span>
            `,
            align: 'center',
            style: {
              "fontWeight": 'bold'
            },
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        }
      },
      navigation: {
        buttonOptions: {
          enabled: false
        }
      },
      chart: {
        events: {
          load: function () {
            setTimeout(function () {
              const graphLoaded = new CustomEvent('graphLoaded');
              window.dispatchEvent(graphLoaded);
            }, 1500);
          },
          beforePrint() {
            this.setTitle({
              text: `
            <b>Average Days to Resolution</b><br/>
            `
            })
          },
          afterPrint() {
            this.setTitle({
              text: null,
              align: 'center',
            })
          }
        },
        height: (expanded ? '50%' : (9 / 16 * 100) + '%') // 16:9 ratio
      },
      title: {
        text: null,
        align: 'left',
        style: {
          "fontWeight": 'bold'
        }
      },
      legend: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      yAxis: {
        visible: false,
      },
      tooltip: {
        // headerFormat: '<b>{point.x}</b><br>',
        formatter: function () {
          return `<b>${this.x}</b> <br>Days to resolution: <b>${this.y}</b><br>Alerts Resolved <b>${series['by' + trendBy][this.point.index].itemsResolved}</b>`;
        }
      },
      series: [{
        name: 'Time to resolution',
        type: 'line',
        data: data,
        color: '#0493FC'
      }],
      xAxis: {
        categories: categories
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: '{y}'
          }
        }
      }
    }

    const trendGraphOptionsToBar = {
      exporting: {
        filename: 'average-days-to-resolution',
        chartOptions: {
          title: {
            text: `
            <b>Average Days to Resolution by ${trendBy}</b><br/>
            <span style="text-align: center; color: #9E9E9E; font-size: small">${startDate} - ${endDate}</span><br/>
            <span style="text-align: center; color: #9E9E9E; font-size: small">Average: ${avgTimetoResolution}</span>
            `,
            align: 'center',
            style: {
              "fontWeight": 'bold'
            },
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        }
      },
      navigation: {
        buttonOptions: {
          enabled: false
        }
      },
      chart: {
        events: {
          load: function () {
            setTimeout(function () {
              const graphLoaded = new CustomEvent('graphLoaded');
              window.dispatchEvent(graphLoaded);
            }, 1500);
          },
          beforePrint() {
            this.setTitle({
              text: `
            <b>Average Days to Resolution</b><br/>
            `
            })
          },
          afterPrint() {
            this.setTitle({
              text: null,
              align: 'center',
            })
          }
        },
        height: (expanded ? '50%' : (9 / 16 * 100) + '%') // 16:9 ratio
      },
      title: {
        text: null,
        align: 'left',
        style: {
          "fontWeight": 'bold'
        }
      },
      legend: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      yAxis: {
        visible: false,
      },
      tooltip: {
        // headerFormat: '<b>{point.x}</b><br>',
        formatter: function () {
          return `<b>${this.x}</b> <br>Days to resolution: <b>${this.y}</b><br>Alerts Resolved <b>${series['by' + trendBy][this.point.index].itemsResolved}</b>`;
        }
      },
      series: [{
        name: 'Time to resolution',
        type: 'column',
        data: data
      }],
      xAxis: {
        categories: categories
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: '{y}'
          }
        }
      }
    }


    this.setState({ trendGraphOptions: trendGraphOptions, trendGraphOptionsToBar: trendGraphOptionsToBar }, () => {
      this.state.trendChartRef.current.chart.reflow()
      this.state.trendChartRefToBar.current.chart.reflow()
    });
  }

  updateBarGraph(expanded: boolean) {

    const { series, filters } = this.state;
    let filteredSeries = series.byAssignee;
    if (!expanded) {
      filteredSeries = filteredSeries.slice(0, 10);
    }

    let startDate = '';
    let endDate = '';
    if (filters && filters.periodFilter) {
      const startDate = format(new Date(filters.periodFilter.split('-')[0].split('/').join('-')), 'M/d/yyyy');
      const endDate = format(new Date(filters.periodFilter.split('-')[1].split('/').join('-')), 'M/d/yyyy');
    }

    const data = filteredSeries.map((item) => { return Number(item.result.toFixed(2)) });
    const categories = filteredSeries.map((item) => { return item.label });
    const barGraphOptions = {
      exporting: {
        enabled: false,
        filename: 'average-days-to-resolution-by-assignee',
        chartOptions: {
          title: {
            text: `
            <b>Average Days to Resolution by Assignee</b><br/>
            <span style="text-align: center; color: #9E9E9E; font-size: small">${startDate} - ${endDate}</span>
            `,
            align: 'center',
            style: {
              "fontWeight": 'bold'
            },
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        }
      },
      chart: {
        events: {
          load: function () {
            setTimeout(function () {
              const barGraphLoaded = new CustomEvent('barGraphLoaded');
              window.dispatchEvent(barGraphLoaded);
            }, 1500);
          },
          beforePrint() {
            this.setTitle({
              text: `
            <b>Average Days to Resolution by Assignee</b><br/>
            `
            })
          },
          afterPrint() {
            this.setTitle({
              text: null,
              align: 'center',
            })
          }
        },
        height: (expanded ? '50%' : (9 / 16 * 100) + '%') // 16:9 ratio
      },
      title: {
        text: null,
        align: 'left',
        style: {
          "fontWeight": 'bold'
        }
      },
      legend: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      yAxis: {
        visible: false,
      },
      series: [{
        name: 'Days to resolution',
        type: 'bar',
        data: data,
        color: '#0493FC'
      }],
      xAxis: {
        categories: categories
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: '{y}'
          }
        }
      }
    }
    this.setState({ barGraphOptions: barGraphOptions }, () => this.state.assigneeChartRef.current.chart.reflow());
  }

  handleFiltersUpdate(filters: any) {
    // set avid list once
    if (this.state.AvidList.length == 0 && filters.AvidsList.length > 0) {
      this.setState({ AvidList: filters.AvidsList });
    }
    const currentFilters = this.state.filters;
    // set list of avid ids being filtered
    let filteredAvidIds = [];
    filters.AvidsList.forEach((avid) => {
      if (filters.teamFilters.filteredList.includes(avid.text)) filteredAvidIds.push(avid.id);
    })
    this.setState({ filters: filters, filteredAvidList: filteredAvidIds }, () => {
      if (!currentFilters || currentFilters.periodFilter != filters.periodFilter) {
        this.getRecords();
      }
      if (currentFilters && currentFilters.trendActiveFilter != filters.trendActiveFilter) {
        this.updateTrendGraph(filters.trendActiveFilter, (this.state.reportExpanded == 'trend'));
      }
      this.updateFilteredRecords();
    });
  }

  updateFilteredRecords() {
    const { filters, records, filteredAvidList } = this.state;
    let updatedRecords = [];
    records.forEach(record => {
      if (
        (filters.reasonFilters.filteredList.includes(record.actionItemReason)) &&
        (filters.statusFilters.filteredList.includes(record.actionItemStatus)) &&
        (filters.sourceFilters.filteredList.includes(record.src)) &&
        (filters.rootCauseFilters.filteredList.includes(record.rootCause)) &&
        (filters.severityFilters.filteredList.includes(record.severityLabel))
      ) {
        if (filteredAvidList.length == 0 || filteredAvidList.includes('myAlerts')) {
          if (record.assignedToId == this.state.userId) updatedRecords.push(record);
        } else {
          if (filteredAvidList.includes(record.avid) || filteredAvidList.includes('Bankwide_0')) updatedRecords.push(record);
        }

      }
    });
    this.setState({ filteredRecords: updatedRecords }, () => {
      this.generateSeries();
    });
    // userData.getUserId().then((userId) => {
    // })
  }

  expandReport(report: string, expand: boolean) {
    let { reportExpanded, filters } = this.state;
    reportExpanded = (expand ? report : '');
    this.setState({ reportExpanded: reportExpanded }, () => {
      if (report == 'trend') {
        this.updateTrendGraph(filters.trendActiveFilter, (this.state.reportExpanded == 'trend'));
      } else {
        this.updateBarGraph((this.state.reportExpanded == 'assignee'));
      }
    });
  }

  // reduce

  /**
   * renderIdColumn
   */
  renderIdColumn(id, record) {
    let isEditMode = false;
    let alert = record;
    let customer = undefined
    const link = "#"
    return (
      <a href={link} className="id-wrapper" onClick={() => {
        this.setState({ selectedAlertID: id }, () => {
          this.setState({ actionAlertFormOpen: true });
        })
      }}>
        <FontAwesomeIcon icon="search" verticalAlign="initial" size="md" />
        <span>&nbsp;{id}</span>
      </a>
    )
  }

  /**
   * renderResolvedColumn
   */
  renderResolvedColumn(resolved: boolean) {
    let tag = '';
    if (resolved) {
      tag = 'Yes';
    } else tag = 'No';
    return (
      <p>{tag}</p>
    )
  }

  loadStatuses() {
    HttpRequest.fetch<IStatusTypes[]>(StatusTypesEndpoint)
      .then((statusTypes) => this.setState({ statusTypes }))

    HttpRequest.fetch<Status[]>('/scripts/my_alerts/get_status')
      .then((statuses) => this.setState({ statuses }))
  }

  getStatus(value: actionAlert): number {
    const { statuses } = this.state

    const status = statuses.find((st) => (st.alert === value.id))
    return (status) ? status.resolutionId : ((value.isActionAlert == true) ? 0 : 3)
  }

  getStatusName(value: actionAlert): IStatusTypes['status'] {
    const { statusTypes } = this.state

    if (statusTypes.length > 0) {
      const statusId = this.getStatus(value)
      const statusType = this.state.statusTypes.find((st) => (statusId !== undefined && statusId === st.id))

      if (statusType) {
        return statusType.status
      }
    }

    return ''
  }

  renderStatusColumn(record: actionAlert) {
    const statusName = record.actionItemStatus
    const isWow = record.isWow;
    const isPerfectScore = record.isPerfectScore;
    const isSalesOpportunity = record.isSalesOpportunity;
    const isAttritionRisk = record.isAttritionRisk;
    let customStyles = '';
    if (!isAttritionRisk) {
      customStyles = customStyles + 'leftAlign';
    }
    if (!isPerfectScore) {
      customStyles = customStyles + ' not-perfect';
    }

    return (
      <article id='status-column' className={customStyles}>
        <Tooltip text={isSalesOpportunity ? 'Sales Opportunity' : 'Not a Sales Opportunity'}>
          <FontAwesomeIcon icon="dollar-sign" color="green" muted={!isSalesOpportunity} />
        </Tooltip>
        <Tooltip text={isAttritionRisk ? 'Attrition Risk' : 'Not an Attrition Risk'}>
          <FontAwesomeIcon icon="asterisk" color="red" muted={!isAttritionRisk} />
        </Tooltip>
        <Tooltip text={isWow ? 'WOW' : 'No WOW'}>
          <FontAwesomeIcon icon="star" color="yellow" muted={!isWow} />
        </Tooltip>
        <Tooltip text={isPerfectScore ? 'Perfect Score' : 'Not a Perfect Score'}>
          <FontAwesomeIcon icon="check" color="green" muted={!isPerfectScore} />
        </Tooltip>
        <Tooltip text={statusName}>
          {getActionStatusIcon(statusName)}
        </Tooltip>
      </article>
    )
  }

  toggleModal(isOpen?: boolean) {
    const { actionAlertFormOpen } = this.state;
    this.setState({ actionAlertFormOpen: !actionAlertFormOpen });
  }


  updateFilterTags(filtersName: string, currentFilterStr: string, currentFilterList) {
    let updatedFiltersList = []
    let filters = this.state.filters;
    currentFilterList.forEach((item) => {
      if (currentFilterStr != item)
        updatedFiltersList.push(item);
    });
    filters[filtersName].filteredList = (updatedFiltersList.length > 0 ? updatedFiltersList : filters[filtersName].defaultList);
    filters[filtersName].isFiltered = (updatedFiltersList.length != 0);
    this.setState({ filters: filters }, () => {
      this.updateFilteredRecords();
    });
  }

  updateTeamFilterTags(filtersName: string, currentFilterStr: string) {
    let filters = this.state.filters;
    let updatedFiltersList = [];
    this.state.filters.teamFilters.filteredList.forEach((i) => {
      if (i != currentFilterStr) updatedFiltersList.push(i);
    })
    filters[filtersName].filteredList = (updatedFiltersList.length > 0 ? updatedFiltersList : filters[filtersName].defaultList);
    filters[filtersName].isFiltered = (updatedFiltersList.length != 0);
    this.setState({ filters: filters }, () => {
      this.updateFilteredRecords();
    });
  }


  isHiddenColumn(prop: string) {
    return this.state.hiddenProperties.indexOf(prop) >= 0
  }

  toggleHiddenColumn(prop: string) {
    const { hiddenProperties } = this.state
    const indexOfProp = hiddenProperties.indexOf(prop)

    if (indexOfProp >= 0) {
      hiddenProperties.splice(indexOfProp, 1)
    } else {
      hiddenProperties.push(prop)
    }

    this.setState({ hiddenProperties })
  }
  toggleBarChartOptions() {
    let { chartBarOptions } = this.state;
    chartBarOptions.dropdownOpen = !chartBarOptions.dropdownOpen;
    this.setState({ chartBarOptions: chartBarOptions });
  }

  toggleExportDropdown(chartName: string) {
    let partialState = {};
    let exportOptions: IChartExportOptions = this.state[chartName + 'ExportOptions'];

    exportOptions.dropdownOpen = !exportOptions.dropdownOpen;

    partialState[chartName + 'ExportOptions'] = exportOptions;

    this.setState(partialState);
  }

  exportTrendChart(option: string) {
    let options = {
      filename: 'average-days-to-resolution',
      type: '',
    }
    const chart = this.state.trendChartRef.current.chart;
    switch (option) {
      case 'print':
        chart.print();
        break;
      case 'png':
        chart.exportChart();
        break;
      case 'jpeg':
        options.type = 'image/jpeg';
        chart.exportChart(options);
        break;
      case 'pdf':
        options.type = 'application/pdf';
        chart.exportChart(options);
        break;
      case 'svg':
        options.type = 'image/svg+xml';
        chart.exportChart(options);
        break;
    }
  }

  exportBarChart(option: string) {
    const chart = this.state.assigneeChartRef.current.chart;
    switch (option) {
      case 'print':
        chart.print();
        break;
      case 'png':
        chart.exportChart();
        break;
      case 'jpeg':
        chart.exportChart({
          type: 'image/jpeg'
        });
        break;
      case 'pdf':
        chart.exportChart({
          type: 'application/pdf'
        });
        break;
      case 'svg':
        chart.exportChart({
          type: 'image/svg+xml'
        });
        break;

    }
  }

  renderCustomerInfo(record: actionAlert): JSX.Element {
    const { customerInfoList } = this.state
    return (
      <span>{resolveCustomerNameOnStatusReport(record, customerInfoList)}</span>
    )
  }

  customSorting(sortBy: string, sortOrder: string, filteredRecords: actionAlert[]): actionAlert[] {
    if (sortBy === 'customerName') {
      return filteredRecords.sort((a, b) =>
        compareCustomerNameOnStatusReport(a, b, this.state.customerInfoList, sortOrder)
      );
    }
    return []
  }


  render() {
    const { trendGraphOptions, trendGraphOptionsToBar, avgTimetoResolution, trendGrpahLoading, barGrpahLoading, barGraphOptions, filteredRecords, recordsLoading, reportExpanded, filters, chartBarOptions, AvidList } = this.state;
    let startDate = '';
    let endDate = '';
    let isBarChart = false

    let reasonFiltersList = [];
    let statusFiltersList = [];
    let sourceFiltersList = [];
    let rootCauseFiltersList = [];
    let severityFiltersList = [];
    let teamsFiltersList = [];
    let selectedTrend = '';

    if (filters && filters.periodFilter) {
      startDate = format(new Date(filters.periodFilter.split('-')[0].split('/').join('-')), 'M/d/yyyy');
      startDate = format(new Date(filters.periodFilter.split('-')[1].split('/').join('-')), 'M/d/yyyy');
      isBarChart = startDate.split('/')[0] === endDate.split('/')[0]
    }

    if (filters && filters.reasonFilters && filters.reasonFilters.isFiltered) reasonFiltersList = filters.reasonFilters.filteredList;
    if (filters && filters.statusFilters && filters.statusFilters.isFiltered) statusFiltersList = filters.statusFilters.filteredList;
    if (filters && filters.sourceFilters && filters.sourceFilters.isFiltered) sourceFiltersList = filters.sourceFilters.filteredList;
    if (filters && filters.rootCauseFilters && filters.rootCauseFilters.isFiltered) rootCauseFiltersList = filters.rootCauseFilters.filteredList;
    if (filters && filters.severityFilters && filters.severityFilters.isFiltered) severityFiltersList = filters.severityFilters.filteredList;
    if (filters && filters.teamFilters && filters.teamFilters.isFiltered) teamsFiltersList = filters.teamFilters.filteredList;
    if (filters && filters.trendActiveFilter) selectedTrend = filters.trendActiveFilter;

    let trendReportExpanded = (reportExpanded == 'trend');
    let assigneeReportExpanded = (reportExpanded == 'assignee');
    return (
      <>
        <div className="row">
          <div className="col-sm-2">
            <ReportsFilersBar
              title='hello world filters bar'
              handler={(filters) => this.handleFiltersUpdate(filters)}
              reasonFilters={reasonFiltersList}
              statusFilters={statusFiltersList}
              sourceFilters={sourceFiltersList}
              rootCauseFilters={rootCauseFiltersList}
              severityFilters={severityFiltersList}
              teamFilters={teamsFiltersList}
            />
          </div>
          <div className="col-sm-10">
            <div className="row">
              {reasonFiltersList.map((filterString, idx) => {
                return (
                  <Button outline color="dark" size="sm" key={idx} style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => {
                    this.updateFilterTags('reasonFilters', filterString, reasonFiltersList);
                  }}>{filterString} <FontAwesomeIcon icon="times" verticalAlign="initial" size="md" /></Button>
                );
              })}
              {statusFiltersList.map((filterString, idx) => {
                return (
                  <Button outline color="dark" size="sm" key={idx} style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => {
                    this.updateFilterTags('statusFilters', filterString, statusFiltersList);
                  }}>{filterString} <FontAwesomeIcon icon="times" verticalAlign="initial" size="md" /></Button>
                );
              })}
              {sourceFiltersList.map((filterString, idx) => {
                return (
                  <Button outline color="dark" size="sm" key={idx} style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => {
                    this.updateFilterTags('sourceFilters', filterString, sourceFiltersList);
                  }}>{filterString} <FontAwesomeIcon icon="times" verticalAlign="initial" size="md" /></Button>
                );
              })}
              {rootCauseFiltersList.map((filterString, idx) => {
                return (
                  <Button outline color="dark" size="sm" key={idx} style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => {
                    this.updateFilterTags('rootCauseFilters', filterString, rootCauseFiltersList);
                  }}>{filterString} <FontAwesomeIcon icon="times" verticalAlign="initial" size="md" /></Button>
                );
              })}
              {severityFiltersList.map((filterString, idx) => {
                return (
                  <Button outline color="dark" size="sm" key={idx} style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => {
                    this.updateFilterTags('severityFilters', filterString, severityFiltersList);
                  }}>{filterString} <FontAwesomeIcon icon="times" verticalAlign="initial" size="md" /></Button>
                );
              })}
              {teamsFiltersList.map((filterString, idx) => {
                const currentAvid = AvidList.find(el => el.text === filterString);
                const parentAvid = AvidList.find(el => el.id === currentAvid.prevLink);
                if ((parentAvid && !teamsFiltersList.includes(parentAvid.text) || !parentAvid)) {
                  return (
                    <Button outline color="dark" size="sm" key={idx} style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => {
                      this.updateTeamFilterTags('teamFilters', filterString);
                    }}>{filterString} <FontAwesomeIcon icon="times" verticalAlign="initial" size="md" /></Button>
                  );
                }
              })}
            </div>
            <div className="row">
              {/* Trend chart*/}
              <div
                className={(reportExpanded.length > 0 ? (reportExpanded == 'trend' ? 'col-sm-12' : 'd-none') : 'col-sm-6 border-right')}>
                <header className="d-flex justify-content-between">
                  <h4>Average Days to Resolution by {selectedTrend}
                    <span
                      className={(trendGrpahLoading ? 'd-none' : 'd-block small text-muted')}>{startDate + ' — ' + endDate}</span>
                    <span
                      className={(trendGrpahLoading ? 'd-none' : 'd-block small text-muted')}>Average: {avgTimetoResolution}</span>
                  </h4>
                  <span className="d-flex justify-content-around chart-report-controls" style={{ flexBasis: '10%' }}>
                    <ExportChart isDropdownOpen={this.state.trendExportOptions.dropdownOpen}
                      toggle={() => this.toggleExportDropdown('trend')} chartRef={(isBarChart ? this.state.trendChartRefToBar : this.state.trendChartRef)}
                      title='Average Days to Resolution' subtitle={startDate + ' — ' + endDate} />
                    <div><i className={(trendReportExpanded ? 'fas fa-compress fa-lg' : 'fas fa-expand fa-lg')}
                      onClick={() => this.expandReport('trend', (!trendReportExpanded))} /></div>
                  </span>
                </header>
                <div className='center-align'>
                  <div className={(trendGrpahLoading ? 'spinner-border' : 'd-none')} role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <div className={(trendGrpahLoading ? 'd-none' : '')}>
                    <div className={(filteredRecords.length > 0 && recordsLoading === false && !isBarChart) ? "d-block" : "d-none"}>
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={trendGraphOptions}
                        allowChartUpdate={true}
                        ref={this.state.trendChartRef}
                      />
                    </div>
                    <div className={(filteredRecords.length > 0 && recordsLoading === false && isBarChart) ? "d-block" : "d-none"}>
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={trendGraphOptionsToBar}
                        allowChartUpdate={true}
                        ref={this.state.trendChartRefToBar}
                      />
                    </div>
                    <div className={(filteredRecords.length > 0 && recordsLoading === false) ? "d-none" : "d-block"} style={{ marginTop: '25%' }}>
                      <div className="alert alert-warning" role="alert">
                        <FontAwesomeIcon icon="sticky-note" verticalAlign="initial" size="md" />
                        <span>&nbsp;No data found for the current filters.</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={(reportExpanded.length > 0 ? (reportExpanded == 'assignee' ? 'col-sm-12' : 'd-none') : "col-sm-6")}>
                <header className="d-flex justify-content-between">
                  <h4>Average Days to Resolution by Assignee
                    <span className={(trendGrpahLoading ? 'd-none' : 'd-block small text-muted')}>{startDate + ' — ' + endDate}</span>
                  </h4>
                  <span className="d-flex justify-content-around chart-report-controls" style={{ flexBasis: '15%' }}>
                    <Dropdown direction="left" isOpen={chartBarOptions.dropdownOpen} toggle={() => this.toggleBarChartOptions()}>
                      <DropdownToggle
                        tag="i"
                        data-toggle="dropdown"
                        aria-expanded={chartBarOptions.dropdownOpen}
                        className="fas fa-pencil-alt fa-lg"
                      >
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem header>Order by value</DropdownItem>
                        <RadioGroup
                          onChange={(order) => {
                            let { chartBarOptions } = this.state;
                            const data = order.toLowerCase();
                            chartBarOptions.orderByValue = (data == 'ascending' ? data : 'descending');
                            let updatedOptions = []
                            chartBarOptions.orderByValueOptions.forEach((item) => {
                              updatedOptions.push({ label: item.label, isChecked: (order == item.label), isEnabled: true });
                            });
                            chartBarOptions.orderByValueOptions = updatedOptions;
                            chartBarOptions.orderBy = "value";
                            this.setState({ chartBarOptions: chartBarOptions }, () => this.generateSeries());
                          }}
                          options={chartBarOptions.orderByValueOptions}
                          optionClass='dropdown-item'
                        >
                        </RadioGroup>
                        <DropdownItem divider />
                        <DropdownItem header>Order by assignee</DropdownItem>
                        <RadioGroup
                          onChange={(order) => {
                            let { chartBarOptions } = this.state;
                            const data = order.toLowerCase();
                            chartBarOptions.orderByAssignee = (data == 'ascending' ? data : 'descending');
                            let updatedOptions = []
                            chartBarOptions.orderByAssigneeOptions.forEach((item) => {
                              updatedOptions.push({ label: item.label, isChecked: (order == item.label), isEnabled: true });
                            });
                            chartBarOptions.orderByAssigneeOptions = updatedOptions;
                            chartBarOptions.orderBy = "assignee";
                            this.setState({ chartBarOptions: chartBarOptions }, () => this.generateSeries());
                          }}
                          options={chartBarOptions.orderByAssigneeOptions}
                          optionClass='dropdown-item'
                        >
                        </RadioGroup>
                      </DropdownMenu>
                    </Dropdown>
                    <ExportChart isDropdownOpen={this.state.barChartExportOptions.dropdownOpen} toggle={() => this.toggleExportDropdown('barChart')} chartRef={this.state.assigneeChartRef} title='Average Days to Resolution By Assignee' subtitle={startDate + ' — ' + endDate} />
                    <div><i className={(assigneeReportExpanded ? "fas fa-compress fa-lg" : "fas fa-expand fa-lg")} onClick={() => this.expandReport('assignee', (assigneeReportExpanded ? false : true))}></i></div>
                  </span>
                </header>
                <div className='center-align'>
                  <div className={(barGrpahLoading ? "spinner-border" : "d-none")} role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <div className={(barGrpahLoading ? "d-none" : "")}>
                    <div className={(filteredRecords.length > 0 && recordsLoading === false) ? "d-block" : "d-none"}>
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={barGraphOptions}
                        allowChartUpdate={true}
                        ref={this.state.assigneeChartRef}
                      />
                    </div>
                    <div className={(filteredRecords.length > 0 && recordsLoading === false) ? "d-none" : "d-block"} style={{ marginTop: '25%' }}>
                      <div className="alert alert-warning" role="alert">
                        <FontAwesomeIcon icon="sticky-note" verticalAlign="initial" size="md" />
                        <span>&nbsp;No data found for the current filters.</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className={(reportExpanded.length > 0 ? 'd-none' : "col-sm-12")}>
                <div className="card">
                  <div className="bg-white table-border-bottom sticky-top card-body" style={{ fontSize: '1rem' }}>
                    <section className="mt-2 d-md-flex justify-content-end">
                      <Popover btnText="Fields">
                        <section style={{ fontSize: '1rem', minWidth: 150, maxHeight: '250px', overflowY: 'scroll' }}>
                          <FormGroup check>
                            <Label>
                              <Input type="checkbox" checked={!this.isHiddenColumn('reason')} onChange={() => this.toggleHiddenColumn('reason')} />
                              <span>&nbsp;Reason for Alert</span>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label>
                              <Input type="checkbox" checked={!this.isHiddenColumn('status')} onChange={() => this.toggleHiddenColumn('status')} />
                              <span>&nbsp;Status</span>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label>
                              <Input type="checkbox" checked={!this.isHiddenColumn('rootCause')} onChange={() => this.toggleHiddenColumn('rootCause')} />
                              <span>&nbsp;Root Cause</span>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label>
                              <Input type="checkbox" checked={!this.isHiddenColumn('severity')} onChange={() => this.toggleHiddenColumn('severity')} />
                              <span>&nbsp;Severity</span>
                            </Label>
                          </FormGroup>
                        </section>
                      </Popover>
                    </section>
                  </div>
                  <div className="card-body">
                    {recordsLoading &&
                      <div className="center-align">
                        <div className={(trendGrpahLoading ? "spinner-border" : "d-none")} role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    }
                    {filteredRecords.length == 0 && recordsLoading == false &&
                      <div className="alert alert-warning" role="alert">
                        <FontAwesomeIcon icon="sticky-note" verticalAlign="initial" size="md" />
                        <span>&nbsp;No data found for the current filters.</span>
                      </div>
                    }
                    {filteredRecords.length > 0 &&
                      <DataGrid<actionAlert>
                        sortBy={this.state.sortBy}
                        sortOrder={this.state.sortOrder}
                        onSortChange={(sortBy, sortOrder) => this.setState({ sortBy, sortOrder }, () => {
                          const updatedRecords = this.customSorting(
                            sortBy,
                            sortOrder,
                            filteredRecords
                          );
                          if (updatedRecords.length > 0)
                            this.setState({ filteredRecords: updatedRecords });
                        })}
                        records={filteredRecords}
                        columns={[
                          { header: 'ID', property: 'id', render: (record) => this.renderIdColumn(record.id, record) },
                          { header: 'Resolved', property: 'resolved', render: (record) => this.renderResolvedColumn(record.resolved) },
                          { header: 'Reason for Alert', property: "actionItemReason", hidden: this.isHiddenColumn('reason') },
                          { header: 'Assignee', property: 'assignedTo' },
                          { header: 'Customer Name', property: 'customerName', render: (record) => this.renderCustomerInfo(record) },
                          { header: 'Status', render: (record) => this.renderStatusColumn(record), hidden: this.isHiddenColumn('status') },
                          { header: 'Source', property: 'src' },
                          { header: 'Root Cause', property: 'rootCause', hidden: this.isHiddenColumn('rootCause') },
                          {
                            header: 'Severity', property: 'severityLabel', render: (record) => {
                              return (
                                <span style={{ color: record.severityColor }}>{record.severityLabel}</span>
                              );
                            }, hidden: this.isHiddenColumn('severity')
                          }
                        ]}
                      />
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ActionAlertFormContainer
          customer={{ name: 'John Doe', email: '', phoneNumber: '888-888-888' }}
          alertID={this.state.selectedAlertID}
          isOpen={this.state.actionAlertFormOpen}
          toggleModal={(isOpen) => this.toggleModal(isOpen)}
        />
      </>
    );
  }
}
